const mapTypes = {
    SET_MAP : 'SET_MAP',
    MY_LOCATION : 'MY_LOCATION',
    ICONS_LAYER : 'ICONS_LAYER',
    CLEAR_ICONS_LAYER: 'CLEAR_ICONS_LAYER',
    ADD_REPORT_LAYER: 'ADD_REPORT_LAYER',
    CLEAR_REPORT_LAYER: 'CLEAR_REPORT_LAYER',
    TOGGLE_IS_MAIN: 'TOGGLE_IS_MAIN',
    TOGGLE_IS_LIVE: 'TOGGLE_IS_LIVE',
    START_COUNT_DOWN: 'START_COUNT_DOWN',
    //TIME INTERVAL LIVE
    REFRESH_COUNTER: 'REFRESH_COUNTER',
    SET_TIMER: 'SET_TIMER',
    SET_MOUNT_LIVE_TIME: 'SET_MOUNT_LIVE_TIME',
    SET_LIVE_PATH: 'SET_LIVE_PATH',
    //TIME INTERVAL MAIN
    SET_REFRESHER: 'SET_REFRESHER',
    REFRESH_REFRESHER: 'REFRESH_REFRESHER',
    REFRESHER_COUNT_DOWN: 'REFRESHER_COUNT_DOWN',
    CHOOSE_MAIN_REFRESHER: 'CHOOSE_MAIN_REFRESHER',
};

export default mapTypes;